import React from 'react';
import PageContainerAuth from '../../components/common/PageContainerAuth';
import TemplateDetailsSection from '../../components/pages/templates/details/TemplateDetailsSection';

export default function TemplateDetails() {
    return (
        <PageContainerAuth section="mailings-templates-template" pageTitle="Template email" backDestination={"/templates"}>
            <TemplateDetailsSection/>
        </PageContainerAuth>
    );
}